import React from 'react';
import PropTypes from 'prop-types';
import { isValid, isText, decodeTags } from '../../../../utils';
import './pros-cons.scss';

const ProsCons = ({
  prosCons,
  isMobile
}) => {
  if (!isValid(prosCons)) {
    return null;
  }
  const { pros, cons } = prosCons;
  const prosHed = isValid(pros.hed) ? pros.hed : "";
  const consHed = isValid(cons.hed) ? cons.hed : "";
  const prosBulletData = isValid(pros.data) ? pros.data : "";
  const consBulletData = isValid(cons.data) ? cons.data : "";
  const prosBulletArr = Object.values(prosBulletData);
  const consBulletArr = Object.values(consBulletData);

  const renderedBulletsList = (bulletData) => bulletData.map((bullet, i) => (
    <li className='bullet' key={i} dangerouslySetInnerHTML={ { __html: decodeTags(bullet) } }></li>)
  );

  return (
    <>
        <div className='pros-cons-wrapper'>
          <div className='pros-list'>
            <h2 className='list-title'>{prosHed}</h2>
            <ul className='bullet-list'>
              {renderedBulletsList(prosBulletArr)}
            </ul>
          </div>
          <hr className='pc-hr'></hr>
          <div className='cons-list'>
            <h2 className='list-title'>{consHed}</h2>
            <ul className='bullet-list'>
              {renderedBulletsList(consBulletArr)}
            </ul>
          </div>
        </div>
    </>
  );
};

ProsCons.propTypes = {
  prosCons: PropTypes.object,
  isMobile: PropTypes.bool,
};

export default ProsCons;
